import {inject, NgModule} from '@angular/core';
import {ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes} from '@angular/router';
import {DashLayoutComponent} from "./modules/dash/layout/dash-layout/dash-layout.component";
import {AuthGuardService} from "./modules/common/modules/auth/services/auth-guard.service";
import {BlogLayoutComponent} from "./modules/blog/layout/blog-layout/blog-layout.component";
import {HomeComponent} from "./modules/web/pages/home/home.component";

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth-config.module').then(m => m.AuthConfigModule)
  },
  {
    path: 'social',
    loadChildren: () => import('./modules/common/modules/social/social.module').then(m => m.SocialModule)
  },
  {
    path: 'dash',
    component: DashLayoutComponent,
    loadChildren: () => import('./modules/dash/dash.module').then(m => m.DashModule),
    canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuardService).canActivate(next, state)],
    canActivateChild: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuardService).canActivate(next, state)]
  },
  {
    path: 'blog',
    component: BlogLayoutComponent,
    loadChildren: () => import('./modules/blog/blog.module').then(m => m.BlogModule),
  },
  {
    path: 'cms',
    loadChildren: () => import('./modules/common/modules/cms/cms.module').then(m => m.CmsModule),
    component: DashLayoutComponent,
    canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuardService).canActivate(next, state)],
    canActivateChild: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuardService).canActivate(next, state)]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoute {
}
